import React from "react";
import { LockedRaffleWheel } from "@/apps/raffle/components/RaffleWheel/LockedRaffleWheel";
import { RaffleWheel } from "@/apps/raffle/components/RaffleWheel/RaffleWheel";
import { RaffleInfoButton } from "@/apps/raffle/components/RaffleWheel/RaffleInfoButton";
import { RaffleResultsEjectScreen } from "@/apps/raffle/components/RaffleResultsEjectScreen/RaffleResultsEjectScreen";
import { useRafflePageContext } from "./RafflePageContext";
import cls from "./styles.module.scss";

export const RaffleWheelSection = () => {
  const { isParticipationComplete, participants, results } =
    useRafflePageContext();
  const hasResults = Boolean(results?.winners.length);
  const shouldShowWheel =
    participants.length > 0 && (isParticipationComplete || hasResults);
  const shouldShowResultsAnimation = Boolean(
    participants.length > 0 && hasResults
  );

  return (
    <div className={cls.wheelCard}>
      <RaffleInfoButton />
      {!shouldShowWheel && <LockedRaffleWheel />}
      {shouldShowWheel && <RaffleWheel />}
      {shouldShowResultsAnimation && <RaffleResultsEjectScreen />}
    </div>
  );
};
